import { computed, SetupContext, unref } from 'vue';
import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import useDirectFlightFilter from '@ve/components/filters/directFlightFilter/desktop/use/useDirectFlightFilter';
import { useState } from 'vuex-composition-helpers';
import _ from 'underscore';

const filtersMappingStoreName = 'mapForFilters';

export default ({ emit }: SetupContext) => {
    const {
        isExclusive,
        products,
        warranted,
        directFlight,
    } = useState<IMapForFiltersState>(filtersMappingStoreName, ['isExclusive', 'warranted', 'products', 'directFlight']);

    const { isPairOfDepartureCityAndArrivalCountryAreValid } = useDirectFlightFilter();

    const selectededFiltersText = computed(() => {
        let text = 'Доп. параметры';
        const numOfSelected = +unref(isExclusive) + +unref(warranted);
        if (numOfSelected) {
            text += `: ${numOfSelected}`;
        }
        return text;
    });

    const isExclusiveFilterShow = computed(() => unref(isExclusive) || !!_.find(unref(products), (product) => product.isExclusive));

    const directFlightFilterShow = computed(() => unref(isPairOfDepartureCityAndArrivalCountryAreValid))

    const isExclusiveChanged = (isExclusiveValue: boolean) => {
        emit('is-exclusive-filter-changed', isExclusiveValue);
    };
    const warrantedChanged = (warrantedValue: boolean) => {
        emit('warranted-filter-changed', warrantedValue);
    };

    const directFlightChanged = (directFlightValue: boolean) => {
        emit('direct-flight-changed', directFlightValue);
    };

    return {
        selectededFiltersText,
        isExclusiveFilterShow,
        isExclusiveChanged,
        warrantedChanged,
        directFlightChanged,
        directFlightFilterShow,
        isExclusiveSelected: isExclusive,
        warrantedSelected: warranted,
        directFlightSelected: directFlight,
    };
};